module.exports = __webpack_public_path__ + "img/Myanmar.29bf5bb3.svg";